var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgBug = function SvgBug(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none",
    viewBox: "0 0 20 20",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0D2976",
    d: "M9.997 2a3 3 0 0 1 3 2.999v.112c0 .49-.397.888-.888.888H7.885a.887.887 0 0 1-.887-.888V5a3 3 0 0 1 3-2.999M3.293 5.293c.39-.39 1.025-.39 1.415 0l2 1.999q.032.033.06.066A3.24 3.24 0 0 1 8.25 7h3.496a3.25 3.25 0 0 1 1.483.357q.028-.033.06-.066l2-2a1.001 1.001 0 0 1 1.414 1.416l-1.999 2q-.033.03-.066.058c.194.375.316.79.347 1.234h2.009a.999.999 0 1 1 0 2h-2c0 .768-.171 1.493-.48 2.143q.102.06.187.15l2 1.999a1.001 1.001 0 0 1-1.416 1.415l-1.971-1.971a4.97 4.97 0 0 1-2.821 1.237V9.497c0-.274-.225-.5-.5-.5s-.5.226-.5.5v7.473a4.97 4.97 0 0 1-2.82-1.237L4.704 17.7a1.001 1.001 0 0 1-1.415-1.415l2-2c.059-.059.121-.106.187-.15a5 5 0 0 1-.478-2.14h-2a.999.999 0 1 1 0-1.999h2.01c.034-.44.156-.859.346-1.234q-.033-.027-.066-.059l-1.999-2a1 1 0 0 1 0-1.414z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBug);
export default ForwardRef;